import { render, staticRenderFns } from "./TermsAcceptCard.vue?vue&type=template&id=805bac5e&scoped=true"
import script from "./TermsAcceptCard.vue?vue&type=script&lang=js"
export * from "./TermsAcceptCard.vue?vue&type=script&lang=js"
import style0 from "./TermsAcceptCard.vue?vue&type=style&index=0&id=805bac5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805bac5e",
  null
  
)

export default component.exports